export default __webpack_public_path__ + "static/fin-identity-startup-d96cd7a130bf8d1e4ed45cc10017d62a.png";